import React, { Component } from 'react';
import './DashboardBox.css';
import CustomDropdown from './../../../Components/Dropdown/CustomDropdown';
import CustomDatePicker from '../../../Components/CustomDatePicker/CustomDatePicker';
import moment from 'moment';
import { startOfDay, endOfDay } from 'date-fns';
import { getOrganizationDate } from '../../../Helpers/Date/OrganizationDate';
import { ToolTip } from '../../../Common';
import { withTranslation } from 'react-i18next';

class DashboardBox extends Component {
  constructor(props) {
    super(props);

    let dashboard_preferences = JSON.parse(
      localStorage.getItem('dashboardPreferences')
    );
    this.state = {
      current_filter: dashboard_preferences,
      currentDateRange: 'month',
      salesOrderSummarySelected: 'month',
      currentFilter: 'quantity',
      isCustomDateRangeSelected: null,
      dateRangePicker: {
        selection: {
          startDate: moment(startOfDay(getOrganizationDate())),
          endDate: moment(endOfDay(getOrganizationDate())),
          key: 'selection',
        },
      },
    };
  }

  dateRangeList = [
    {
      id: 'today',
      label: this.props.t('common.today'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'week',
      label: this.props.t('common.week'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'month',
      label: this.props.t('common.month'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'thirty_days',
      label: this.props.t('common.thirty_days'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'six_months',
      label: this.props.t('common.six_months'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'year',
      label: this.props.t('common.year'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'last_year',
      label: this.props.t('common.last_year'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'total',
      label: this.props.t('common.total'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'custom',
      label: this.props.t('common.custom'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
  ];

  dateRangeList2 = [
    {
      id: 'today',
      label: this.props.t('common.today'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'week',
      label: this.props.t('common.week'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'thirty_days',
      label: this.props.t('common.thirty_days'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'month',
      label: this.props.t('common.month'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'six_months',
      label: this.props.t('common.six_months'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'year',
      label: this.props.t('common.year'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    {
      id: 'last_year',
      label: this.props.t('common.last_year'),
      onClick: (id) => this.handleDateRangeFilter(id),
    },
    // {
    //   id: 'custom',
    //   label: 'Custom',
    //   onClick: (id) => this.handleDateRangeFilter(id),
    // },
  ];

  filters = [
    {
      id: 'quantity',
      label: this.props.t('ListTable.quantity'),
      onClick: (id) => this.handleFilter(id),
    },
    {
      id: 'amount',
      label: this.props.t('common.amount'),
      onClick: (id) => this.handleFilter(id),
    },
  ];
  salesOrderSummary = [
    {
      id: 'today',
      label: this.props.t('common.today'),
      onClick: (id) => this.handleSalesOrderSummary(id),
    },
    {
      id: 'week',
      label: this.props.t('common.week'),
      onClick: (id) => this.handleSalesOrderSummary(id),
    },
    {
      id: 'month',
      label: this.props.t('common.month'),
      onClick: (id) => this.handleSalesOrderSummary(id),
    },
    {
      id: 'thirty_days',
      label: this.props.t('common.thirty_days'),
      onClick: (id) => this.handleSalesOrderSummary(id),
    },
    {
      id: 'six_months',
      label: this.props.t('common.six_months'),
      onClick: (id) => this.handleSalesOrderSummary(id),
    },
    {
      id: 'year',
      label: this.props.t('common.year'),
      onClick: (id) => this.handleSalesOrderSummary(id),
    },
    {
      id: 'last_year',
      label: this.props.t('common.last_year'),
      onClick: (id) => this.handleSalesOrderSummary(id),
    },
    {
      id: 'total',
      label: this.props.t('common.total'),
      onClick: (id) => this.handleSalesOrderSummary(id),
    },
    {
      id: 'custom',
      label: this.props.t('common.custom'),
      onClick: (id) => this.handleSalesOrderSummary(id),
    },
  ];

  handleSalesOrderSummary(filter) {
    this.setState({
      salesOrderSummarySelected: filter,
      current_filter: {
        ...this.state.current_filter,
        sales_order_summary: filter,
      },
    });
  }

  handleDateRangeFilter(filter) {
    let currentcard = sessionStorage.getItem('card');
    let new_db_default = {};
    switch (currentcard) {
      case this.props.t('Dashboard.salesInformation'):
        {
          new_db_default = {
            ...this.state.currentFilter,
            sales_information: filter,
          };
        }
        break;
      case this.props.t('Dashboard.packageAndShipment'):
        {
          new_db_default = {
            ...this.state.currentFilter,
            package_and_shipment: filter,
          };
        }
        break;
      case this.props.t('Dashboard.purchaseInformation'):
        {
          new_db_default = {
            ...this.state.currentFilter,
            purchase_information: filter,
          };
        }
        break;
      case this.props.t('Dashboard.receivables'):
        {
          new_db_default = {
            ...this.state.currentFilter,
            receivables: filter,
          };
        }
        break;
      case this.props.t('Dashboard.payables'):
        {
          new_db_default = {
            ...this.state.currentFilter,
            payable: filter,
          };
        }
        break;
      case this.props.t('Dashboard.topSellingItems'):
        {
          new_db_default = {
            ...this.state.currentFilter,
            top_selling_items: filter,
          };
        }
        break;

      case this.props.t('Dashboard.topCustomers'):
        {
          new_db_default = {
            ...this.state.currentFilter,
            top_customers: filter,
          };
        }
        break;
      case this.props.t('Dashboard.salesVsPurchase'):
        {
          new_db_default = {
            ...this.state.currentFilter,
            sales_vs_purchase: filter,
          };
        }
        break;
      default:
        return;
    }
    this.setState({
      currentDateRange: filter,
      current_filter: new_db_default,
    });
    // this.handleUpdateData(filter)
  }

  handleFilter(filter) {
    this.setState({ currentFilter: filter });
  }

  handleRangeChange = (range) => {
    this.setState({
      dateRangePicker: {
        ...this.state.dateRangePicker,
        selection: {
          ...this.state.dateRangePicker.selection,
          startDate: moment(startOfDay(range.selection.startDate)),
          endDate: moment(endOfDay(range.selection.endDate)),
        },
      },
    });
  };

  getinitalvalue = (module) => {
    // console.log(module)
    switch (module) {
      case this.props.t('Dashboard.salesInformation'):
        return this.state.current_filter.sales_information;
      case this.props.t('Dashboard.packageAndShipment'):
        return this.state.current_filter.package_and_shipment;
      case this.props.t('Dashboard.purchaseInformation'):
        return this.state.current_filter.purchase_information;
      case this.props.t('Dashboard.receivables'):
        return this.state.current_filter.receivables;
      case this.props.t('Dashboard.payables'):
        return this.state.current_filter.payable;
      case this.props.t('Dashboard.topSellingItems'):
        return this.state.current_filter.top_selling_items;
      case this.props.t('Dashboard.topCustomers'):
        return this.state.current_filter.top_customers;
      case this.props.t('Dashboard.salesVsPurchase'):
        return this.state.current_filter.sales_vs_purchase;
      case this.props.t('Dashboard.salesOrderSummary'):
        return this.state.current_filter.sales_order_summary;
      default:
        return 'month';
    }
  };
  render() {
    const {
      className,
      hasDateRange = true,
      salesOrderSummaryFlag,
      salevspurchaseFlag,
      t,
      i18n,
    } = this.props;
    const { salesOrderSummarySelected, dateRangePicker } = this.state;

    return (
      <div className={`dashboard_box ${className ? className : ''}`}>
        <div className="dashboard_box_header">
          <p>
            {this.props.title}{' '}
            {this.props.ToolTip ? (
              <span className="dashboardtitleTootip">
                <ToolTip content={this.props.ToolTip} />
              </span>
            ) : null}
          </p>
          {this.props.subTitile ? (
            <p>
              {this.props.subTitile === 'Confirmed Orders' ||
              this.props.subTitile === '已确认订单'
                ? `${this.props.subTitile}`
                : `  ( ${this.props.subTitile} )  `}
            </p>
          ) : (
            <p />
          )}
          {this.props.filter && (
            <span>
              <CustomDropdown
                className="summary-timeline--date-range"
                textLabel={
                  this.filters.find(
                    (option) => option.id === this.state.currentFilter
                  ).label
                }
                options={this.filters}
              />
            </span>
          )}

          {salesOrderSummaryFlag && (
            <span className="dashboard_box_header_dropdown ">
              {salesOrderSummarySelected === 'custom' && (
                <CustomDatePicker
                  type="range"
                  fromDashboard
                  ranges={dateRangePicker}
                  months={1}
                  onChange={this.handleRangeChange}
                />
              )}
              <CustomDropdown
                fromDashboard
                className="summary-timeline--date-range"
                textLabel={
                  this.salesOrderSummary.find(
                    (option) =>
                      option.id === this.getinitalvalue(this.props.title)
                  ).label
                }
                options={this.salesOrderSummary}
              />
            </span>
          )}
          {hasDateRange && !salesOrderSummaryFlag && (
            <span className="dashboard_box_header_dropdown">
              {this.state.currentDateRange === 'custom' && (
                <CustomDatePicker
                  type="range"
                  fromDashboard
                  ranges={dateRangePicker}
                  months={1} //commnet this portion if you want to disable custom date picker
                  onChange={this.handleRangeChange}
                />
              )}
              <CustomDropdown
                fromDashboard
                module={this.props.title}
                className={`summary-timeline--date-range ${
                  this.state.currentDateRange === 'custom' && 'custom_name'
                }`}
                textLabel={
                  salevspurchaseFlag
                    ? this.dateRangeList2.find(
                        (option) =>
                          option.id === this.getinitalvalue(this.props.title)
                      ).label
                    : this.dateRangeList.find(
                        (option) =>
                          option.id === this.getinitalvalue(this.props.title)
                      )?.label
                }
                options={
                  salevspurchaseFlag ? this.dateRangeList2 : this.dateRangeList
                }
              />
            </span>
          )}
        </div>
        <div className="float-left w-100 data_section">
          {this.props.render(
            this.state.current_filter,
            this.props.filter
              ? this.state.currentFilter
              : dateRangePicker.selection.startDate.format(
                  'YYYY-MM-DD HH:mm:ss'
                ),
            dateRangePicker.selection.endDate.format('YYYY-MM-DD HH:mm:ss'),
            salesOrderSummarySelected,
            this.props.filter &&
              dateRangePicker.selection.startDate.format('YYYY-MM-DD HH:mm:ss')
          )}
        </div>
      </div>
    );
  }
}
export default withTranslation()(DashboardBox);
